import React,{useContext ,useRef} from 'react';
import { useReactToPrint } from "react-to-print";
import { Mizania_table_print } from './mizania_table_print';
import { GlobalContext } from '../../../context/provider';
import money_rounding from '../../../utils/money_rounding';
import numberbeautify from '../../../utils/numberbeautify';
import show_million_format from '../../../utils/show_million_format';

const Mizania_table = ({mizania_date, total_previous_warehouse_price, total_warehouse_price, total_previous_loan_sold, total_loan_sold, total_previous_loan_bought, total_loan_bought, assets, fixed_assets, current_assets, funding_sources, current_liabilities}) => {
    const { initState } = useContext(GlobalContext);
    
    const printRef = useRef();
                
    const printFn = useReactToPrint({
        contentRef: printRef,
        documentTitle: "mizania_table",
        preserveAfterPrint: true,
        print: (printIframe) =>
        new Promise(() => {
            printIframe.style.display = "none";
            printIframe.contentWindow?.print();
        }),
    });
    return (
        <div>
            <div
                style={{
                position: 'absolute',
                left: '-99999px',
                top: 0
                }}
            >
                <Mizania_table_print ref={printRef} mizania_date={mizania_date} total_previous_warehouse_price={total_previous_warehouse_price} total_warehouse_price={total_warehouse_price} total_previous_loan_sold={total_previous_loan_sold} total_loan_sold={total_loan_sold} total_previous_loan_bought={total_previous_loan_bought} total_loan_bought={total_loan_bought} assets={assets} fixed_assets={fixed_assets} current_assets={current_assets} funding_sources={funding_sources} current_liabilities={current_liabilities} />
            </div>
            <div className="mt-6">
                {/* Category List Card */}
                <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                    
                    {/* Section Header */}
                    <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                        <h2 className="text-base font-semibold text-slate-800">
                            الميزانية العامة كما في {mizania_date}/12/31
                        </h2>
                    </div>

                    {/* Table */}
                    <table className="w-full">
                        <thead>
                            <tr className="bg-slate-50 border-b border-slate-100">
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    رقم الكشف
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    رقم الدليل
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    اسم الحساب
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    السنة الحالية (دينار/الف)
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                    السنة السابقة (دينار/الف)
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    1
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    الموجودات
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                            </tr>
                            {assets?.map((item, index)=>(
                                <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_statement_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_directory_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {item?.mizania_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(item?.current_amount)))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(item?.previous_amount)))}
                                    </td>
                                </tr>
                            ))}
                            {assets?.length>0&&<tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    المجموع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                                </td>
                            </tr>}
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    الموجودات الثابتة
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                            </tr>
                            {fixed_assets?.map((item, index)=>(
                                <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_statement_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_directory_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {item?.mizania_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(item?.current_amount)))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(item?.previous_amount)))}
                                    </td>
                                </tr>
                            ))}
                            {fixed_assets?.length>0&&<tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    المجموع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(fixed_assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0) || 0))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(fixed_assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0) || 0))))}
                                </td>
                            </tr>}
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    الموجودات المتداولة
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    137
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    المخزون
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(total_warehouse_price)))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(total_previous_warehouse_price)))}
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    15
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    المدينون
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(total_loan_sold)))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(total_previous_loan_sold)))}
                                </td>
                            </tr>
                            {current_assets?.map((item, index)=>(
                                <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_statement_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_directory_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {item?.mizania_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(parseFloat(item?.current_amount || 0))))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(parseFloat(item?.previous_amount || 0))))}
                                    </td>
                                </tr>
                            ))}
                            {(current_assets?.length>0||total_loan_sold>0||total_previous_loan_sold>0||total_previous_warehouse_price>0||total_warehouse_price>0)&&<tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    المجموع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(Number(current_assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(total_loan_sold)+Number(total_warehouse_price))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(Number(current_assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(total_previous_loan_sold)+Number(total_previous_warehouse_price))))}
                                </td>
                            </tr>}
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    مجموع الموجودات
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    {numberbeautify(show_million_format(money_rounding(Number(assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(fixed_assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(current_assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(total_loan_sold)+Number(total_warehouse_price))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    {numberbeautify(show_million_format(money_rounding(Number(assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(fixed_assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(current_assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(total_previous_loan_sold)+Number(total_previous_warehouse_price))))}
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    2
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    مصادر التمويل
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                            </tr>
                            {funding_sources?.map((item, index)=>(
                                <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_statement_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_directory_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {item?.mizania_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(parseFloat(item?.current_amount || 0))))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(parseFloat(item?.previous_amount || 0))))}
                                    </td>
                                </tr>
                            ))}
                            {funding_sources?.length>0&&<tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    المجموع
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(funding_sources?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(funding_sources?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                                </td>
                            </tr>}
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline">
                                    المطلوبات المتداولة
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                            </tr>
                            <tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    4
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                    26
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    الدائنون
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(total_loan_bought)))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(total_previous_loan_bought)))}
                                </td>
                            </tr>
                            {current_liabilities?.map((item, index)=>(
                                <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_statement_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-center">
                                        {item?.mizania_directory_number}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {item?.mizania_name}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(parseFloat(item?.current_amount || 0))))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(parseFloat(item?.previous_amount || 0))))}
                                    </td>
                                </tr>
                            ))}
                            {(current_liabilities?.length>0||(Number(total_loan_bought)>0)||(Number(total_previous_loan_bought)>0))&&
                                <tr className="hover:bg-slate-50 transition-colors duration-100">
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        المجموع
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(Number(current_liabilities?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(total_loan_bought))))}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {numberbeautify(show_million_format(money_rounding(Number(current_liabilities?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(total_previous_loan_bought))))}
                                    </td>
                                </tr>}
                            {(current_liabilities?.length>0||funding_sources?.length>0||(Number(total_loan_bought)>0)||(Number(total_previous_loan_bought)>0))&&<tr className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    مجموع مصادر التمويل
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(Number(funding_sources?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0)) + Number(current_liabilities?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(total_loan_bought))))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(show_million_format(money_rounding(Number(funding_sources?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0)) + Number(current_liabilities?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(total_previous_loan_bought))))}
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
                <div className="mt-5 w-full">
                    <button
                        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-3 px-4 rounded h-12 w-full"
                        onClick={() => {
                            printFn();
                        }}
                    >
                        پرینت
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Mizania_table